<div class="login-page">
  <div class="page-bg"></div>
  <div class="page-scrim"></div>
  <div class="orb orb--one"></div>
  <div class="orb orb--two"></div>
  <div class="orb orb--three"></div>
  <div class="grid-overlay"></div>

  <div class="login-content">
    <div class="visual-panel">
      <div class="visual-panel__brand">
        <div class="logo-mark">
          <img src="/itrace-logo.jpeg" alt="iTrace" />
        </div>
        <span class="brand-name">iTrace</span>
      </div>

      <h1 class="visual-panel__headline">
        Cross Border<br />
        <span class="gradient-text">Data Exchange</span>
      </h1>
      <p class="visual-panel__tagline">
        The trusted network moving verified trade data across borders — encrypted, compliant, instant.
      </p>

      <div class="network-graphic">
        <svg viewBox="0 0 400 260" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="link" d="M60 200 C 120 120, 160 100, 200 130" />
          <path class="link" d="M200 130 C 250 160, 280 90, 340 60" />
          <path class="link" d="M200 130 C 170 180, 140 210, 90 220" />
          <path class="link" d="M200 130 C 240 140, 290 190, 330 210" />

          <circle class="node node--core" cx="200" cy="130" r="10" />
          <circle class="node" cx="60" cy="200" r="6" />
          <circle class="node" cx="340" cy="60" r="6" />
          <circle class="node" cx="90" cy="220" r="6" />
          <circle class="node" cx="330" cy="210" r="6" />

          <circle class="pulse" cx="200" cy="130" r="10" />
        </svg>

        <div class="floating-chip floating-chip--one">
          <span class="material-icons">lock</span>
          256-bit encryption
        </div>
        <div class="floating-chip floating-chip--two">
          <span class="material-icons">verified</span>
          ISO 27001 certified
        </div>
        <div class="floating-chip floating-chip--three">
          <span class="material-icons">bolt</span>
          Real-time sync
        </div>
      </div>

      <div class="stat-row">
        <div class="stat">
          <strong>42+</strong>
          <span>Countries</span>
        </div>
        <div class="stat">
          <strong>99.9%</strong>
          <span>Uptime</span>
        </div>
        <div class="stat">
          <strong>24/7</strong>
          <span>Monitoring</span>
        </div>
      </div>
    </div>

    <div class="auth-panel">
      <form class="glass-card" (ngSubmit)="submit()" #loginForm="ngForm">
        <div class="glass-card__header">
          <h2>Welcome back</h2>
          <p>Sign in to access your dashboard</p>
        </div>

        <div class="field">
          <div class="field__control">
            <span class="material-icons field__icon">mail_outline</span>
            <input
              type="email"
              name="email"
              [(ngModel)]="email"
              required
              autocomplete="username"
              placeholder=" "
              id="email"
            />
            <label for="email">Email address</label>
          </div>
        </div>

        <div class="field">
          <div class="field__control">
            <span class="material-icons field__icon">lock_outline</span>
            <input
              [type]="showPassword() ? 'text' : 'password'"
              name="password"
              [(ngModel)]="password"
              required
              autocomplete="current-password"
              placeholder=" "
              id="password"
            />
            <label for="password">Password</label>
            <button
              type="button"
              class="field__toggle"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
            >
              <span class="material-icons">{{ showPassword() ? 'visibility_off' : 'visibility' }}</span>
            </button>
          </div>
        </div>

        @if (errorMessage()) {
          <p class="error">
            <span class="material-icons">error_outline</span>
            {{ errorMessage() }}
          </p>
        }

        <button type="submit" class="submit-btn" [disabled]="loginForm.invalid || isSubmitting()">
          @if (isSubmitting()) {
            <span class="spinner"></span>
            <span>Signing in...</span>
          } @else {
            <span>Sign in</span>
            <span class="material-icons">arrow_forward</span>
          }
        </button>

        <div class="divider"><span>or</span></div>

        <div class="glass-card__footer">
          <span>Don't have an account?</span>
          <a routerLink="/register">Register your company</a>
        </div>

        <div class="glass-card__footer">
          <span>Already on itrace?</span>
          <a routerLink="/register-via-portal">Register via the itrace portal</a>
        </div>
      </form>
    </div>
  </div>
</div>
